import { useState } from "react";
import { Stack, Typography, Link, Box } from "@mui/material";
import { ModalBasic } from "../components/modal/ModalBasic";
import { useTranslation } from "react-i18next";
import flexBox from "../assets/styles/common/flexBox.module.css";
import footer from "../assets/styles/layouts/footer.module.css";
import {
  PRIVACY_POLICY,
  INTERNAL_REGULATIONS,
} from "../constants/homepageTexts";
import { color } from "echarts";


function Copyright(props) {
  const { t } = useTranslation();
  return (
    <Typography
      variant="body2"
      align="center"
      {...props}
      // className={colors.textWhite}
    >
      {"Copyright © "}
      <Link color="inherit" href={process.env.REACT_APP_HOMEPAGE_URL} style={{ textDecoration: 'none', cursor: 'hand', }} sx={{ paddingRight: '4px'}}>
        {t('header.mycompany')}
      </Link>
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const Footer = () => {
  const { t } = useTranslation();
  const [modal, setModal] = useState({ open: false, contentKey: null });

  const handleOpen = (key) => {
    setModal({ open: true, contentKey: key });
  };

  const handleClose = () => {
    setModal({ open: false, contentKey: null });
  };

  const modalContent =
    modal.contentKey === "PRIVACY_POLICY"
      ? PRIVACY_POLICY
      : INTERNAL_REGULATIONS;

  //<footer style={{ backgroundColor: "#29314A", height: "150px", width: "100%", bottom: 0, position: "absolute" }}> , 3B4972
  return (
    <footer>
      <Box
        className='footer-container'
        sx={{
          pt: 3,
          pl: { xs: 0, md: 3 },
          pr: { xs: 0, md: 3 },
          pb: { xs: 3, md: 3 },
        }}
      >
        <Box
          className='footer-content'
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "space-between" },
            alignItems: "center",
            height: "100%",
            width: "100%",
            pt: { xs: 0, md: 1 },
            pb: { xs: 0, md: 1 },
          }}
        >
          <Link href="/" style={{ textDecoration: 'none', cursor: 'hand' }}>
            <Typography component="div" sx={{ pb: { xs: 3, md: 0 }, textAlign: { xs: "center" } }}>
                {/* <img src={`${process.env.PUBLIC_URL}/images/footer/flogo.svg`} alt="flogo" className={footer.footerFlogo} width={60} /> */}
                <img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="flogo" className={footer.footerFlogo} width={100} />
            </Typography>
          </Link>

          <Stack direction={{ sm: 'column', md: 'row' }} spacing={0} className={`${flexBox.flexRowAllCenter}`} sx={{ pb: { xs: 3, md: 0 }, alignItems: "center" }}>
            <Link color="inherit" underline="hover" style={{ cursor: 'hand' }} onClick={() => handleOpen("PRIVACY_POLICY")}>
              <Typography component="div" sx={{ p: 0, m: 0, textAlign: 'center', minWidth: '250px' }} >
                {t('header.PRIVACY_POLICY')}
              </Typography>
            </Link>
            <Link color="inherit" underline="hover" style={{ cursor: 'hand' }} onClick={() => handleOpen("INTERNAL_REGULATIONS")}>
              <Typography component="div" sx={{ p: 0, m: 0, textAlign: 'center', minWidth: '250px' }} >
                {t('header.INTERNAL_REGULATIONS')}
              </Typography>
            </Link>
          </Stack>

          <Link href="https://www.busan.go.kr/index" style={{ textDecoration: 'none', cursor: 'hand' }} target="_blank">
            <Typography component="div" sx={{ pb: { xs: 3, md: 0 }, textAlign: { xs: "center" } }} >
                <img src={`${process.env.PUBLIC_URL}/images/footer/blogo.svg`} alt={`${t('header.supportcompany')} Logo`} className={footer.footerBlogo} width={100} />
            </Typography>
          </Link>
          
        </Box>
        
        {/* Copyright 영역 */}
        <Copyright />
        
      </Box>

      {/* Modal Dialog */}
      <ModalBasic open={modal.open} onClose={handleClose} title={modalContent.title} content={modalContent.content} />

    </footer>
  );
};

export default Footer;
